<template>
  <div class="main-container">
    <tl-header type="h1">
      <div>Joinings</div>
      <template slot="icon" v-if="!showIntro">
        <div class="row-container">
          <div class="showIntro" v-on:click="goToIntro">
            <img class="imgClass" src="@/assets/questionmark.png" />
          </div>
        </div>
      </template>
    </tl-header>
    <div>
      <div class="row-container center">
        <div class="company-info" v-show="showIntro">
          <img class="image" src="@/assets/team.svg" />
          <div v-on:click="hideIntro">
            <img class="closeImage" src="@/assets/close.png" />
          </div>
          <div class="fontStyle">
            <span>Any new employee joined in your legal entity in current month can be added here. If you have already added them, they will show here.</span>
          </div>
        </div>
      </div>
      <div>
        <joinings />
      </div>
    </div>
  </div>
</template>

<script>
import Joinings from "./Joining.vue";
export default {
  name: "JoiningIntro",
  components: { Joinings },
  data() {
    return {
      showIntro: true
    };
  },
  methods: {
    /** to hide the intro screen if paygroups available */
    hideIntro() {
      this.showIntro = false;
    },
    /** to show the intro screen if paygroups are not available */
    goToIntro() {
      this.showIntro = true;
    },
    /** Navigation */
    cancel() {
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/payroll`
      });
    },
    next() {
      this.$router.push({
        path: `/payroll/run/${
          this.$route.params.entity_index ? this.$route.params.entity_index : 0
        }/exits`
      });
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@/scss/components/introPage.scss";
.line {
  border-bottom: 1px solid #34c0be;
  flex-grow: 1;
  margin-top: 15%;
}
.btnGrp {
  float: right;
}
</style>
